import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientMedicationsSelector } from '../selectors'
import { setPatientMedicationsList } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedicationsState } from '../store/patientMedications.types'

export function* setFrequency() {
  const patientMedications: IPatientMedicationsState = yield select(getPatientMedicationsSelector)
  const { frequency, patientMedication, patientMedicationsList } = patientMedications
  const selectedMedication = patientMedicationsList.filter((medication) => medication.key === patientMedication?.key)
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].frequency = frequency
    yield put(setPatientMedicationsList(patientMedicationsList))
  }
}
export function* setFrequencySaga() {
  yield takeLatest([PatientMedicationsConstants.SET_FREQUENCY], setFrequency)
}
